import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';

import { crossbeamApi } from '@/api';
import { usePartnersStore } from '@/stores';

export function usePartnersUsingPreset(presetId?: number | null) {
  const partnersStore = usePartnersStore();
  const { partnerOrgs } = storeToRefs(partnersStore);

  const isLoading = ref(true);
  const partnerIdsUsingPreset = ref<number[]>([]);

  async function getPartnersUsingPreset() {
    if (!presetId) return;

    const { data, error } = await crossbeamApi.GET(
      '/v0.1/data-share-presets/{id}/impacted-partners',
      {
        params: {
          path: {
            id: presetId,
          },
        },
      },
    );
    if (error) throw error;

    partnerIdsUsingPreset.value = data.partner_ids;
  }

  onMounted(async () => {
    await getPartnersUsingPreset();
    isLoading.value = false;
  });

  // Find partners that use the default preset at least once
  const partnersUsingPreset = computed(() =>
    partnerOrgs.value.filter((org) =>
      partnerIdsUsingPreset.value.includes(org.id),
    ),
  );

  return { partnersUsingPreset, isLoading };
}
